/* RESPONSIBLE TEAM: team-standalone */

import Controller from '@ember/controller';
import { action } from '@ember/object';

export default class FrameDevController extends Controller {
  queryParams = ['external_id', 'external_type', 'theme', 'app_id_code'];

  external_id = null;
  external_type = 'ZENDESK_TICKET';
  theme = 'none';
  app_id_code = 'tx2p130c';

  @action setParams(paramName: string, paramValue: string) {
    this.set(paramName as keyof this, paramValue);
  }
}
